/* eslint-disable import/prefer-default-export */
/**
 *
 *
 * @export
 * @class ErrorParser
 */
export class ErrorParser {
    /**
     *
     *
     * @static
     * @param {String} string - original error string
     * @returns
     * @memberof ErrorParser
     */
    static parse(string) {
        if (string.startsWith('GraphQL error: ')) return string.slice('GraphQL error: '.length);

        return string;
    }
}
